"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationPriorityEnum = void 0;
var ConversationPriorityEnum;
(function (ConversationPriorityEnum) {
    ConversationPriorityEnum["Urgent"] = "U";
    ConversationPriorityEnum["High"] = "H";
    ConversationPriorityEnum["Medium"] = "M";
    ConversationPriorityEnum["Low"] = "L";
})(ConversationPriorityEnum = exports.ConversationPriorityEnum || (exports.ConversationPriorityEnum = {}));
